import setting from '@/setting.js'

/**
 * 元数据
 * @type {{requiresAuth: boolean}} requiresAuth为true表示需要授权登录后访问
 */
const meta = {requiresAuth: false}

/**
 * 使用配置文件指定对应的布局
 * @returns {Promise<*>|*}
 */
let layout = function () {
    // 布局模式，默认值1
    // 0-经典布局
    // 1-适合内网管理系统的布局
    // 2-适合门户网站的布局
    // 3-与公司原Angular版本相似的布局
    // 4-国光项目定制布局
    if (setting.layout.layoutType == 1) {
        return import('@/layout/header-aside')
    } else if (setting.layout.layoutType == 2) {
        return import('@/layout/header-aside/layout-public')
    } else if (setting.layout.layoutType == 0) {
        return import('@/layout/header-aside/layout-d2admin')
    } else if (setting.layout.layoutType == 3) {
        return import('@/layout/header-aside/layout-eversec-angular')
    } else if (setting.layout.layoutType == 4) {
        return import('@/layout/header-aside/layout-gg')
    } else {
        // 适合内网管理系统的布局
        return import('@/layout/header-aside')
    }
}

/**
 * 在主框架内显示
 */
const frameIn = [
    {
        path: '/',
        redirect: {name: 'login'},
        component: layout,
        meta: {meta, title: 'GPU用量统计'},
        children: [
            {
                path: '/dashboard',
                name: 'dashboard',
                component: () => import('../pages/user-module/dashboard'),
            },
            {
                path: '/user-balancelist',
                name: 'user-balancelist',
                component: () => import('../pages/user-module/user-balancelist'),
            },
            {
                path: '/user-recharge-record',
                name: 'user-recharge-record',
                component: () => import('../pages/user-module/user-balancelist/user-recharge-record'),
            },
            {
                path: '/user-recharge',
                name: 'user-recharge',
                component: () => import('../pages/user-module/user-balancelist/user-recharge'),
            },
            {
                path: '/userOrdin-billing-month',
                name: 'userOrdin-billing-month',
                component: () => import('../pages/user-module/userOrdin-billing-month'),
            },
            {
                path: '/user-list',
                name: 'user-list',
                component: () => import('../pages/user-module/user-list'),
            },
            
            {
                path: '/user-billing-month',
                name: 'user-billing-month',
                component: () => import('../pages/user-module/user-billing-month'),
            },
            {
                path: '/user-billing-day',
                name: 'user-billing-day',
                component: () => import('../pages/user-module/user-billing-day'),
            },
            {
                path: '/user-billing-details',
                name: 'user-billing-details',
                component: () => import('../pages/user-module/user-billing-details'),
            },

            

            {
                path: '/user-cost',
                name: 'user-cost',
                component: () => import('../pages/gpu-usage/user-cost'),
            },
            {
                path: '/ns-usage',
                name: 'ns-usage',
                component: () => import('../pages/gpu-usage/ns-usage'),
            },
            {
                path: '/pod-usage',
                name: 'pod-usage',
                component: () => import('../pages/gpu-usage/pod-usage'),
            },
            {
                path: '/gpu-price',
                name: 'gpu-price',
                component: () => import('../pages/gpu-usage/price'),
            },

                {
                    path: '/api/resource-requests',
                    name: 'resourceRequests',
                    component: () => import('../pages/bare-metal/resource-requests'),
                    meta: {meta, title: '资源请求'}
                },
                {
                    path: '/api/resource-requests/details',
                    name: 'resourceRequestDetails',
                    component: () => import('../pages/bare-metal/resource-requests/resource-request-details'),
                    meta: {meta, title: '资源请求详情'}
                },
                {
                    path: '/api/regions',
                    name: 'region',
                    component: () => import('../pages/bare-metal/region'),
                    meta: {meta, title: '提供商'}
                },
                {
                    path: '/api/zones',
                    name: 'availableZones',
                    component: () => import('../pages/bare-metal/available_zones'),
                    meta: {meta, title: '可用区域'}
                },
                 {
                    path: '/api/compute-types',
                    name: 'computeTypes',
                    component: () => import('../pages/bare-metal/compute-types'),
                    meta: {meta, title: '资源类型'}
                },
                {
                    path: '/computeTypeDetails',
                    name: 'computeTypeDetails',
                    component: () => import('../pages/bare-metal/compute-types/compute-type-details'),
                    meta: {meta, title: '资源类型详情'}
                },
                {
                    path: '/api/compute-products',
                    name: 'computeProducts',
                    component: () => import('../pages/bare-metal/compute-products'),
                    meta: {meta, title: '算力规格'}
                },
                {
                    path: '/computeProductDetails',
                    name: 'computeProductDetails',
                    component: () => import('../pages/bare-metal/compute-products/compute-product-details'),
                    meta: {meta, title: '算力规格详情'}
                },
                {
                    path: '/api/devices',
                    name: 'devicesList',
                    component: () => import('../pages/bare-metal/device-list'),
                    meta: {meta, title: '设备列表'}
                },
                {
                    path: '/showDetails',
                    name: 'showDetails',
                    component: () => import('../pages/bare-metal/devices-list/show-details'),
                    meta: {meta, title: '设备详情'}
                },
                {
                    path: '/api/orders',
                    name: 'orderList',
                    component: () => import('../pages/bare-metal/order-list'),
                    meta: {meta, title: '订单管理'}
                },
                {
                    path: '/orderShowDetails',
                    name: 'orderShowDetails',
                    component: () => import('../pages/bare-metal/order-list/order-details'),
                    meta: {meta, title: '合同详情'}
                },
                {
                    path: '/orderDelivery',
                    name: 'orderDelivery',
                    component: () => import('../pages/bare-metal/order-list/order-delivery'),
                    meta: {meta, title: '交付管理'}
                },
                {
                    path: '/api/bills',
                    name: 'billList',
                    component: () => import('../pages/bare-metal/bill-list'),
                    meta: {meta, title: '账单管理'}
                },
                {
                    path: '/billShowDetails',
                    name: 'billShowDetails',
                    component: () => import('../pages/bare-metal/bill-list/bill-details'),
                    meta: {meta, title: '账单明细'}
                },
                {
                    path: '/api/fault-events',
                    name: 'faultList',
                    component: () => import('../pages/bare-metal/fault-list'),
                    meta: {meta, title: '故障列表'}
                },
                {
                    path: '/api/statistics/count',
                    name: 'resourceUsage',
                    component: () => import('../pages/bare-metal/resource-usage'),
                    meta: {meta, title: '资源使用统计'}
                },
                {
                    path: '/api/user-orders',
                    name: 'computingPowerUsage',
                    component: () => import('../pages/bare-metal/computingPower-usage'),
                    meta: {meta, title: '算力使用情况'}
                },
                {
                    path: '/api/user-providers',
                    name: 'computingPowerOccupation',
                    component: () => import('../pages/bare-metal/computingPower-occupation'),
                    meta: {meta, title: '算力占用情况'}
                },
                {
                    path: '/api/opportunities',
                    name: 'userList',
                    component: () => import('../pages/bare-metal/opportunities'),
                    meta: {meta, title: '商机管理'}
                },
                {
                    path: '/api/menu',
                    name: 'userList',
                    component: () => import('../pages/bare-metal/menu'),
                    meta: {meta, title: '菜单列表'}
                },
                {
                    path: '/api/user',
                    name: 'userList',
                    component: () => import('../pages/bare-metal/user'),
                    meta: {meta, title: '用户列表'}
                },
                {
                    path: '/api/roles',
                    name: 'userList',
                    component: () => import('../pages/bare-metal/roleUser'),
                    meta: {meta, title: '角色列表'}
                },
                {
                    path: '/api/logs/login',
                    name: 'userList',
                    component: () => import('../pages/bare-metal/log/loginLog.vue'),
                    meta: {meta, title: '登录日志'}
                },
                {
                    path: '/api/logs/operation',
                    name: 'userList',
                    component: () => import('../pages/bare-metal/log/operationLog.vue'),
                    meta: {meta, title: '操作日志'}
                },
                     

            // {  // 工时统计
            //     path: '/workhours',
            //     name: 'workhours',
            //     component: () => import('../pages/workhours'),
            //     children: [
            //         {
            //             path: '/workhours-calendar',
            //             name: 'workhours-calendar',
            //             component: () => import('../pages/workhours/calendar'),
            //             meta: {meta, title: '月度汇总'}
            //         },
            //         {
            //             path: '/workhours-calendar-project',
            //             name: 'workhours-calendar-project',
            //             component: () => import('../pages/workhours/calendar/index_project.vue'),
            //             meta: {meta, title: '月度汇总'}
            //         },
            //         {
            //             path: '/workhours-summary',
            //             name: 'workhours-summary',
            //             component: () => import('../pages/workhours/summary'),
            //             meta: {meta, title: '汇总统计'}
            //         },
            //         {
            //             path: '/workhours-summary-list',
            //             name: 'workhours-summary-list',
            //             component: () => import('../pages/workhours/summary-list'),
            //             meta: {meta, title: '汇总明细'}
            //         },
            //     ]
            // },
        ]
    },
]

/**
 * 在主框架之外显示
 */
const frameOut = [
    // 登陆
    {
        path: '/login',
        name: 'login',
        component: () => import('@/pages/login')
    }
]

/**
 * 错误页面
 */
const errorPage = [
    // 404
    {
        path: '*',
        name: '404',
        component: () => import('@/pages/error-page-404')
    }
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
    ...frameIn,
    ...frameOut,
    ...errorPage
]
